/**
 * Labstep
 *
 * @module components/Molecule/Action/Edit
 * @desc Action to update comment post
 */

import { MoleculePlaceholder } from 'labstep-web/components/Molecule/Placeholder';
import { MoleculeShowContainer as MoleculeShow } from 'labstep-web/components/Molecule/Show';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { MediaQueryMobile as Mobile } from 'labstep-web/core/MediaQuery/Mobile';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type {
  MoleculeActionEditContainerProps,
  MoleculeActionEditProps,
} from './types';

export const MoleculeActionEdit: React.FC<
  MoleculeActionEditProps
> = ({ molecule, isMobile, canEdit, onDone, parent, ...rest }) => (
  <Modal
    size="fullscreen"
    header="Chemistry"
    formatContent={isMobile}
    content={({ toggleModal }) => {
      const onClose = onDone || toggleModal;
      return isMobile ? (
        <MoleculePlaceholder onClose={onClose} />
      ) : (
        <MoleculeShow
          id={molecule.getId}
          canEdit={canEdit}
          onDone={onClose}
          parent={parent}
        />
      );
    }}
    viewComponent={({ toggleModal }) => (
      <ActionComponent
        type="option"
        text="Edit"
        icon="pencil"
        onClick={toggleModal}
      />
    )}
    closeIcon={false}
    {...rest}
  />
);

export const MoleculeActionEditContainer: React.FC<
  MoleculeActionEditContainerProps
> = (props) => (
  <Mobile>
    {({ match }) => (
      <MoleculeActionEdit isMobile={match} {...props} />
    )}
  </Mobile>
);
